// src/services/api.js
const API_BASE_URL = 'https://agi-vmssys.atlanticgrains.com/api';
//const API_BASE_URL = 'http://192.168.101.2:9099/api';
//const AUTH_HEADER = 'Basic c21hcnRwcm9iZTpQQCQkdzByZEAyMDIy';
const AUTH_HEADER = 'Basic ' + btoa('smartprobe:P@$$w0rd@2022');
// API service class
class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.authHeader = AUTH_HEADER;
  }

  // Generic HTTP request method with enhanced error handling
  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.authHeader.replace(/=/g, ''), // Remove '=' characters like in mobile app
        ...options.headers
      },
      ...options
    };

    console.log('Making request to:', url);
    console.log('Request config:', config);

    try {
      const response = await fetch(url, config);
      
      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Response data:', data);
      return data;
    } catch (error) {
      console.error('API request failed:', error);
      
      // More specific error messages
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        throw new Error('Network error: Unable to connect to server. Please check your internet connection and try again.');
      } else if (error.name === 'TypeError' && error.message.includes('CORS')) {
        throw new Error('CORS error: Server is not configured to accept requests from this domain.');
      } else {
        throw error;
      }
    }
  }

  // Authentication methods with enhanced error handling
  async login(credentials) {
    try {
      console.log('Attempting login with credentials:', { username: credentials.username, password: '***' });
      
      // Use the same endpoint and parameter names as your mobile app
      const response = await this.request('/login/', {
        method: 'POST',
        body: JSON.stringify({
          "username": credentials.username,
          "pass": credentials.password  // Note: 'pass' instead of 'password'
        })
      });
      
      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Login failed:', error);
      
      let userFriendlyMessage = 'Login failed. Please try again.';
      
      if (error.message.includes('Network error')) {
        userFriendlyMessage = 'Unable to connect to server. Please check your internet connection.';
      } else if (error.message.includes('CORS')) {
        userFriendlyMessage = 'Server configuration error. Please contact your system administrator.';
      } else if (error.message.includes('401')) {
        userFriendlyMessage = 'Invalid username or password.';
      } else if (error.message.includes('403')) {
        userFriendlyMessage = 'Access denied. Please contact your system administrator.';
      } else if (error.message.includes('500')) {
        userFriendlyMessage = 'Server error. Please try again later.';
      }
      
      return {
        success: false,
        error: userFriendlyMessage,
        originalError: error.message
      };
    }
  }

  // Test connection method
  async testConnection() {
    try {
      const response = await fetch(this.baseURL + '/');
      return {
        success: response.ok,
        status: response.status,
        statusText: response.statusText
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Future methods for purchases (unchanged)
  async getPurchases() {
    try {
      const response = await this.request('/purchases/');
      return {
        success: true,
        data: response
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async createPurchase(purchaseData) {
    try {
      const response = await this.request('/purchases/', {
        method: 'POST',
        body: JSON.stringify(purchaseData)
      });
      
      return {
        success: true,
        data: response
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async updatePurchase(id, purchaseData) {
    try {
      const response = await this.request(`/purchases/${id}/`, {
        method: 'PUT',
        body: JSON.stringify(purchaseData)
      });
      
      return {
        success: true,
        data: response
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async deletePurchase(id) {
    try {
      const response = await this.request(`/purchases/${id}/`, {
        method: 'DELETE'
      });
      
      return {
        success: true,
        data: response
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }
}

// Create and export a single instance
const apiService = new ApiService();
export default apiService;